import { render } from "./list-item-with-actions.vue?vue&type=template&id=6096bf92"
import script from "./list-item-with-actions.vue?vue&type=script&lang=js"
export * from "./list-item-with-actions.vue?vue&type=script&lang=js"
script.render = render

export default script